module.exports = __webpack_public_path__ + "static/media/logo.db0aa150.png";